import { Link, NavLink } from "react-router-dom";
import { Instagram } from "lucide-react";
import { NAV } from "@/constants/testIds";

const LINKS = [
  { to: "/", label: "Work", testId: NAV.linkWork },
  { to: "/studio", label: "Studio", testId: NAV.linkStudio },
  { to: "/ai-films", label: "AI Films", testId: NAV.linkAiFilms },
  { to: "/contact", label: "Contact", testId: NAV.linkContact },
];

const linkClass = ({ isActive }) =>
  `transition-colors ${isActive ? "text-[#CCFF00]" : "text-[#888880] hover:text-[#F5F5F0]"}`;

const trialPillClass = ({ isActive }) =>
  `inline-flex items-center gap-1.5 shrink-0 font-mono text-xs sm:text-sm uppercase tracking-widest px-3 min-h-[36px] sm:min-h-[40px] transition-colors ${
    isActive ? "bg-[#E5FF66] text-black" : "bg-[#CCFF00] text-black hover:bg-[#E5FF66]"
  }`;

export const Nav = ({ rightSlot }) => (
  <header data-testid="site-nav" className="sticky top-0 z-40 w-full border-b border-[#2A2A2A] bg-[#101010]/85 backdrop-blur-md">
    <div className="max-w-[1600px] mx-auto h-14 sm:h-16 md:h-20 px-3 sm:px-6 flex items-center justify-between gap-3">
      <Link
        to="/"
        data-testid={NAV.wordmark}
        className="flex items-center shrink-0 opacity-100 hover:opacity-80 transition-opacity"
      >
        <img src="/eipi-logo.png" alt="EiPi Media" className="h-6 sm:h-7 md:h-8 w-auto" />
      </Link>
      <nav className="hidden sm:flex items-center gap-5 md:gap-8 font-mono text-sm uppercase tracking-widest">
        {LINKS.map((l) => (
          <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={l.testId} className={linkClass}>
            {l.label}
          </NavLink>
        ))}
      </nav>
      <div className="flex items-center gap-2 sm:gap-3 shrink-0">
        <NavLink to="/instagram-trial" data-testid={NAV.linkInstagramTrial} className={trialPillClass}>
          <Instagram size={12} />
          <span className="hidden sm:inline">Try Instagram Films</span>
          <span className="sm:hidden">IG Films</span>
        </NavLink>
        {rightSlot}
      </div>
    </div>
    <div className="sm:hidden flex items-center gap-5 overflow-x-auto no-scrollbar px-3 h-10 border-t border-[#2A2A2A] font-mono text-sm uppercase tracking-widest">
      {LINKS.map((l) => (
        <NavLink key={l.to} to={l.to} end={l.to === "/"} data-testid={`${l.testId}-mobile`} className={linkClass}>
          {l.label}
        </NavLink>
      ))}
    </div>
  </header>
);

export default Nav;
